import { render, staticRenderFns } from "./talent.vue?vue&type=template&id=4db68716&scoped=true"
import script from "./talent.vue?vue&type=script&lang=js"
export * from "./talent.vue?vue&type=script&lang=js"
import style0 from "./talent.vue?vue&type=style&index=0&id=4db68716&prod&lang=scss&scoped=true"
import style1 from "./talent.vue?vue&type=style&index=1&id=4db68716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db68716",
  null
  
)

export default component.exports